import ActionButton from "@/components/buttons/ActionButton";
import { Card, Form } from "antd";
import { useTranslation } from "react-i18next";
import { ChinaCompetitionResultFilterPageRequest } from "../types";
import { ChinaCompetitionFilterForm } from "./forms/ChinaCompetitionFilterForm";

type Props = {
  searchParams: ChinaCompetitionResultFilterPageRequest;
  updateSearchParams: (params: ChinaCompetitionResultFilterPageRequest, append?: boolean, replace?: boolean) => void;
};

export const ChinaCompetitionFilter = ({ searchParams, updateSearchParams }: Props) => {
  const { t } = useTranslation();

  const [filterForm] = Form.useForm<ChinaCompetitionResultFilterPageRequest>();

  return (
    <Card
      className="card-box"
      title={<h2>{t("page.competitionChina")}</h2>}
      extra={
        <ActionButton
          color="danger"
          size="middle"
          variant="outlined"
          icon="reload"
          onClick={() => {
            filterForm.resetFields();
            updateSearchParams(filterForm.getFieldsValue());
          }}
        >
          {t("common.resetFilter")}
        </ActionButton>
      }
    >
      <ChinaCompetitionFilterForm searchParams={searchParams} form={filterForm} onFilterSubmit={updateSearchParams} />
    </Card>
  );
};
